export default {"src":"/_next/static/media/box-scoops.076bcfc6.svg","height":54,"width":149,"blurWidth":0,"blurHeight":0};